import * as service from './service'

export default {
  namespace: 'equipmentMallSureOrder',
  state: {
    payAgentData: [],
    getOrderData: {},
    backOrderData: {},
    orderInfoData: {},
    payOrderData: {}
  },
  effects: {
    * getPayAgentList ({ payload }, { call, put }) {
      const res = yield call(service.getPayAgentList, payload)
      yield put({
        type: 'save',
        payload: {
          payAgentData: res.data.data
        }
      })
      return res.data
    },
    * getCreatOrderData ({ payload }, { call, put }) {
      const res = yield call(service.getCreatOrderData, payload)
      yield put({
        type: 'save',
        payload: {
          getOrderData: res.data.data
        }
      })
      return res.data
    },
    * getOrderInfo ({ payload }, { call, put }) {
      const res = yield call(service.getOrderInfo, payload)
      yield put({
        type: 'save',
        payload: {
          orderInfoData: res.data.data
        }
      })
      return res.data
    },
    * creatOrderData ({ payload, bizCodeHandler, bizCodes }, { call, put }) {
      const res = yield call(service.creatOrderData, payload, bizCodeHandler, bizCodes)
      yield put({
        type: 'save',
        payload: {
          backOrderData: res.data.data
        }
      })
      return res.data
    },
    * payOrder ({ payload }, { call, put }) {
      const res = yield call(service.payOrder, payload)
      yield put({
        type: 'save',
        payload: {
          payOrderData: res.data.data
        }
      })
      return res.data
    },
    * getCouponList ({ payload }, { call, put }) {
      const res = yield call(service.getCouponList, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
